import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { getCombinedOrderClientFieldConfig } from "helpers/orderClientFields";
import {
  buildGroupedPreparationRows,
  formatPreparationDateLabel,
} from "helpers/orderPreparationReports";
import { Order } from "types";

type Props = {
  orders: Order[];
};

export default function OrderPreparationGroupedPrint({ orders }: Props) {
  const rows = buildGroupedPreparationRows(orders);
  const clientFieldConfig = getCombinedOrderClientFieldConfig(orders);
  const showLote = clientFieldConfig.detail.showLote;
  const showOc = clientFieldConfig.detail.showOc;
  const showFechaVencimiento = clientFieldConfig.detail.showFechaVencimiento;
  const showPeso = clientFieldConfig.detail.showPeso;
  const columnsCount =
    8 +
    (showLote ? 1 : 0) +
    (showOc ? 1 : 0) +
    (showFechaVencimiento ? 1 : 0) +
    (showPeso ? 1 : 0);

  return (
    <TableContainer
      component={Paper}
      sx={{
        border: "1px solid grey",
        borderRadius: "0.5rem",
        padding: "1rem",
      }}
    >
      <Typography variant="h6" mb={1}>
        Reporte agrupado de preparación
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Código</TableCell>
            <TableCell align="center">Descripción</TableCell>
            {showLote && <TableCell align="center">Lote</TableCell>}
            {showOc && <TableCell align="center">OC</TableCell>}
            <TableCell align="center">Cantidad</TableCell>
            <TableCell align="center">Cant. x Cont.</TableCell>
            <TableCell align="center">Cant. Restante</TableCell>
            <TableCell align="center">Subtotal</TableCell>
            {showPeso && <TableCell align="center">Peso</TableCell>}
            {showFechaVencimiento && (
              <TableCell align="center">Fecha Venc.</TableCell>
            )}
            <TableCell align="center">Ubicación</TableCell>
            <TableCell align="center">Observación</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.key}>
              <TableCell align="center">{row.articleCode}</TableCell>
              <TableCell align="center">{row.description}</TableCell>
              {showLote && <TableCell align="center">{row.lote ?? "-"}</TableCell>}
              {showOc && <TableCell align="center">{row.oc ?? "-"}</TableCell>}
              <TableCell align="center">{row.totalAmount}</TableCell>
              <TableCell align="center">{row.amountPerContainer}</TableCell>
              <TableCell align="center">{row.totalRemainingAmount}</TableCell>
              <TableCell align="center">{row.totalUnits}</TableCell>
              {showPeso && <TableCell align="center">{row.totalWeight}</TableCell>}
              {showFechaVencimiento && (
                <TableCell align="center">
                  {formatPreparationDateLabel(row.fechaVencimiento)}
                </TableCell>
              )}
              <TableCell align="center">{row.locationCode}</TableCell>
              <TableCell align="center">{row.observations.join(" | ")}</TableCell>
            </TableRow>
          ))}

          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={columnsCount} align="center">
                No hay mercadería para mostrar.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
